
export default [
  /** 个人中心 */
  {
    path: '/mine/index', // 我的
    name: 'MineIndex',
    component: () => import('@/view/mine/Index')
  },
  {
    path: '/mine/bills', // 我的账单
    name: 'Bills',
    component: () => import('@/view/mine/Bills')
  },

  {
    path: '/mine/monthcard', // 我的月卡
    name: 'MonthCard',
    component: () => import('@/view/mine/MonthCard')
  },
  {
    path: '/mine/coupons', // 我的优惠券
    name: 'Coupons',
    component: () => import('@/view/mine/Coupons')
  },
  {
    path: '/mine/wechatNotice', // 车场管理
    name: 'WechatNotice',
    component: () => import('@/view/mine/WechatNotice')
  },
]



// WEBPACK FOOTER //
// ./src/router/mine.js